import { Route, Routes } from 'react-router-dom';
import ScrollToTop from '@/components/ScrollToTop';
import Index from '../pages/Index';
import LifeInsuranceGuide from '../pages/LifeInsuranceGuide';
import InsuranceCalculator from '../pages/InsuranceCalculator';
import FAQ from '../pages/FAQ';
import About from '../pages/About';
import HowItWorks from '../pages/HowItWorks';
import Carriers from '../pages/Carriers';
import Reviews from '../pages/Reviews';
import Contact from '../pages/Contact';
import Blog from '../pages/Blog';
import BlogPost from '../pages/BlogPost';
import PrivacyPolicy from '../pages/legal/PrivacyPolicy';
import TermsOfService from '../pages/legal/TermsOfService';
import Licenses from '../pages/legal/Licenses';
import Disclosures from '../pages/legal/Disclosures';
import Accessibility from '../pages/legal/Accessibility';
import NotFound from '../pages/NotFound';
import Dashboard from '../pages/Dashboard';
import AuthCallback from '../pages/AuthCallback';
import CreatePasswordPage from '../pages/onboarding/CreatePassword';
import ProfileInfoPage from '../pages/onboarding/ProfileInfo';
import OnboardingFlow from '../pages/onboarding/OnboardingFlow';
import Onboarding from '../pages/Onboarding';
import Profile from '../pages/Profile';
import Account from '../pages/Account';
import AuthTestPage from '../pages/auth/AuthTestPage';
import Signin from '../pages/Signin';

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
      <Route path="/" element={<Index />} />
      <Route path="/signin" element={<Signin />} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/onboarding" element={<Onboarding />} />
      <Route path="/onboarding/create-password" element={<CreatePasswordPage />} />
      <Route path="/onboarding/profile" element={<ProfileInfoPage />} />
      <Route path="/onboarding/flow" element={<OnboardingFlow />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="/account" element={<Account />} />
      {/* Dev auth test page (env-flagged) */}
      {import.meta.env.VITE_SHOW_AUTH_TEST === 'true' && (
        <Route path="/dev/auth-test" element={<AuthTestPage />} />
      )}
      <Route path="/guide" element={<LifeInsuranceGuide />} />
      <Route path="/calculator" element={<InsuranceCalculator />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/about" element={<About />} />
      <Route path="/how-it-works" element={<HowItWorks />} />
      <Route path="/carriers" element={<Carriers />} />
      <Route path="/reviews" element={<Reviews />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/legal/privacy" element={<PrivacyPolicy />} />
      <Route path="/legal/terms" element={<TermsOfService />} />
      <Route path="/legal/licenses" element={<Licenses />} />
      <Route path="/legal/disclosures" element={<Disclosures />} />
      <Route path="/legal/accessibility" element={<Accessibility />} />
      {/* Legacy redirects */}
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms" element={<TermsOfService />} />
      <Route path="/licenses" element={<Licenses />} />
      <Route path="/disclosures" element={<Disclosures />} />
      <Route path="/accessibility" element={<Accessibility />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
    </>
  );
};

export default AppRoutes;